// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-legal-assist-cmb/form-item-legal-assist-cmb.component.scss
// module id = 936
// module chunks = 0